import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import { bindActionCreators } from "redux";
import { Route, Switch } from "react-router-dom";
// import CompanyProfileCreate from "./company-profile-create";
import CompanyProfileCreate from "./new-company-profile-create";
import CompanyDetailsDrawer from "./company-details-drawer";
import CompanyLosProfiles from "./company-los-profiles";
import CompanyInvoices from "./invoices";
import CompanySyncRequest from "./sync-request";
import VisibilityView from "./visibility-view";
import LedgerUploadPage from "./ledger-upload-page";
class Companies extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Switch>
                    {this.props.companiesList ? (
                        <Route
                            exact
                            path={"/app/companies"}
                            component={CompanyLosProfiles}
                        />
                    ) : null}
                    <Route
                        exact
                        path={"/app/companies/create"}
                        component={CompanyProfileCreate}
                    />
                    <Route
                        path={"/app/companies/invoices"}
                        component={CompanyInvoices}
                    />
                    <Route
                        path={"/app/companies/upload-ledger"}
                        component={LedgerUploadPage}
                    />
                    <Route
                        exact
                        path={"/app/companies/:companyId"}
                        component={CompanyDetailsDrawer}
                    />
                    <Route
                        exact
                        path={"/app/companies/sync/request"}
                        component={CompanySyncRequest}
                    />
                    <Route
                        exact
                        path={"/app/companies/sync/request/:companyId/:companyName"}
                        component={VisibilityView}
                    />
                </Switch>

            </React.Fragment>
        );
    }
}

Companies.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    companiesList: PropTypes.bool
};

const mapStateToProps = (state) => ({
    companiesList: state.user.getIn(["permissions", "page_companies_listing"])
});

export default connect(mapStateToProps, null) (Companies);
